<template>
  <div>
    <div>
      <div>
        <table>
          <thead>
          <tr>
            <td>Format</td>
            <td>Stamps</td>
            <td>Standard Franking</td>
            <td>Mailmark Franking</td>
            <td>Stamps to Mailmark Saving</td>
            <td>Franking to Mailmark Saving</td>
            <td>VOLUMES</td>
            <td>Stamps to Mailmark SAVING TOTAL</td>
            <td>Franking to Mailmark SAVING TOTAL</td>
          </tr>
          </thead>

          <tbody>
          <tr>
            <td colspan="12"><h4>1st class mail</h4></td>
          </tr>
          <tr v-for="data, index in table1['class1_letters']">
            <td>{{ index }}</td>
            <td>&pound;{{ data['stamps'].toFixed(2) }}</td>
            <td>&pound;{{ data['standard_franking'].toFixed(2) }}</td>
            <td>&pound;{{ data['mailmark_franking'].toFixed(2) }}</td>
            <td>&pound;{{ data['stamps_saving'].toFixed(2) }}</td>
            <td>&pound;{{ data['franking_saving'].toFixed(2) }}</td>
            <td>
              <span v-if="index === 'Standard letter' && !data['volumes']">{{ table1['class1_post_percentage_value'] }}</span>
              <span v-if="index === 'Standard letter' && data['volumes']">{{ data['volumes'] }}</span>
              <span v-if="index !== 'Standard letter'">{{ data['volumes'] }}</span>
            </td>
            <td>{{ data['stamps_saving_total'] ? '&pound;' + data['stamps_saving_total'].toFixed(2) : null }}</td>
            <td>{{ data['franking_saving_total'] ? '&pound;' + data['franking_saving_total'].toFixed(2) : null }}</td>
          </tr>
          <tr>
            <td colspan="12"><h4>2nd class mail</h4></td>
          </tr>
          <tr v-for="data, index in table1['class2_letters']">
            <td>{{ index }}</td>
            <td>&pound;{{ data['stamps'].toFixed(2) }}</td>
            <td>&pound;{{ data['standard_franking'].toFixed(2) }}</td>
            <td>&pound;{{ data['mailmark_franking'].toFixed(2) }}</td>
            <td>&pound;{{ data['stamps_saving'].toFixed(2) }}</td>
            <td>&pound;{{ data['franking_saving'].toFixed(2) }}</td>
            <td>
              <span v-if="index === 'Standard letter' && !data['volumes']">{{ table1['class2_post_percentage_value'] }}</span>
              <span v-if="index === 'Standard letter' && data['volumes']">{{ data['volumes'] }}</span>
              <span v-if="index !== 'Standard letter'">{{ data['volumes'] }}</span>
            </td>
            <td>{{ data['stamps_saving_total'] ? '&pound;' + data['stamps_saving_total'].toFixed(2) : null }}</td>
            <td>{{ data['franking_saving_total'] ? '&pound;' + data['franking_saving_total'].toFixed(2) : null }}</td>
          </tr>
          <tr>
            <td colspan="7"><h4>Total savings: </h4></td>
            <td><h6><b>I89</b> &pound;{{ table1['totals']['stamps_saving'].toFixed(2) }}</h6></td>
            <td><h6><b>I90</b> &pound;{{ table1['totals']['franking_saving'].toFixed(2) }}</h6></td>
          </tr>
          </tbody>
        </table>
      </div>

      <div style="margin-top:20px;">
        <table>
          <tr>
            <td>LETTERS</td>
            <td>PACKETS</td>
            <td>TOTAL</td>
          </tr>
          <tr>
            <td><b>C1</b> {{ results.letters }}
            </td>
            <td><b>C2</b> {{ results.packets }}</td>
            <td><b>C3</b> {{ results.total }}</td>
          </tr>
        </table>
        <table style="margin-top:10px;">
          <tr>
            <td>Equipment lease costs</td>
            <td><b>C8</b> &pound;{{ current_costs['equipment_lease_costs'].toFixed(2) }}</td>
          </tr>
          <tr>
            <td>Service costs (if purchased or paid annually)</td>
            <td><b>C9</b> &pound;{{ current_costs['service_costs'].toFixed(2) }}</td>
          </tr>
          <tr>
            <td>Consumable Ink costs</td>
            <td><b>C10</b> &pound;{{ current_costs['consumable_ink_costs'].toFixed(2) }}</td>
          </tr>
          <tr>
            <td>Consumable label costs</td>
            <td><b>C11</b> &pound;{{ current_costs['consumable_label_costs'].toFixed(2) }}</td>
          </tr>
          <tr>
            <td>Postage Recredit costs</td>
            <td>
              <b>C12</b> &pound;{{ current_costs['postage_recredit_costs'].toFixed(2) }}
            </td>
          </tr>
          <tr>
            <td>Invoice Fees</td>
            <td><b>C13</b> &pound;{{ current_costs['invoice_fees'].toFixed(2) }}</td>
          </tr>
          <tr>
            <td>Insurance Fees</td>
            <td><b>C14</b> &pound;{{ current_costs['insurance_fees'].toFixed(2) }}</td>
          </tr>
          <tr>
            <td>TOTAL COST PER ANNUM</td>
            <td><b>C15</b> &pound;{{ current_costs['total_cost_per_annum'].toFixed(2) }} </td>
          </tr>
        </table>
      </div>

    </div>

  </div>
</template>
<script>
  export default {
    props: ["results"],
    data() {
      return {}
    },
    computed: {
      table1 () {
        return this.results.table1
      },
      current_costs () {
        return this.results.current_costs
      }
    },
    watch: {
      results: (updatedResults) => {
        // console.log(updatedResults)
        this.table1 = updatedResults.table1
        this.current_costs = updatedResults.current_costs
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Debug/QuoteInfo/CalculationTables.vue